import { useAttrs } from "vue";
import { camelCase } from "lodash-es";

// We can pass in the types of the emits options in vue-style:
// defineSyncEmits<{
//   (event: "update", paramA: string, paramB: number): void;
//   (event: "delete", paramA: string): void;
// })();

type EmitFunction = (event: any, ...args: any[]) => any;

/**
 * Alternative to defineEmits from vue, allowing for events with return values.
 */
export function defineSyncEmits<T extends EmitFunction>() {
  const attrs = useAttrs();
  return function emit(...args: Parameters<T>) {
    type EventName = Parameters<T>[0];
    const eventKey = args[0] as EventName;
    const eventName = `on${camelCase(eventKey).replace(/^./, (m) => m.toUpperCase())}`;
    const emitter = attrs?.[eventName] as
      | ((...args: Parameters<T>[]) => ReturnType<T>)
      | undefined;

    if (!emitter) {
      console.warn(
        `Could not find event ${eventKey} in attributes. Make sure component uses inheritAttrs: false and leaves out the "emits" option.`
      );
      throw new Error(`Event ${eventKey} not found in attributes.`);
    }

    return emitter(...args.slice(1));
  }
}
